import { Observable } from "rxjs";
import { BaseGridResponse } from "../../data/shared/base-grid.response";
import { BaseRequest } from "../../data/shared/base.request";
import { GetServicesRequest, Service, ServiceRequest, TransportServiceRequest } from "../domain";
import { DeleteServiceRequest } from "../domain/requests/services/delete-service.request";

export abstract class ServicesRepository {
  abstract getServices(request: BaseRequest<GetServicesRequest>): Observable<BaseGridResponse<Service>>;

  abstract addService(request: ServiceRequest[]): Observable<boolean>;

  abstract addOtherDistributorsService(request: ServiceRequest[]): Observable<boolean>;

  abstract addEditTransportService(request: TransportServiceRequest[]): Observable<boolean>;

  abstract editService(request: ServiceRequest): Observable<boolean>;

  abstract deleteService(request: DeleteServiceRequest): Observable<boolean>;
}
